import React from 'react'
import { classed, deriveClassed } from '@tw-classed/react'

const Item = classed('span', 'inline-flex justify-center items-center')

export interface ICssIconProps extends React.ComponentProps<typeof Item> {
  containerClassName?: string
  containerProps?: React.HtmlHTMLAttributes<HTMLSpanElement>
}

// ref: https://tw-classed.vercel.app/docs/derived-components#deriveclassed
export const CssIcon = deriveClassed<typeof Item, ICssIconProps>(
  (props, ref) => {
    const { containerClassName, containerProps, ...rest } = props

    if (containerClassName) {
      return (
        <CssIcon ref={ref} {...containerProps} className={containerClassName}>
          <Item {...rest} />
        </CssIcon>
      )
    }

    return <Item ref={ref} {...rest} />
  },
)
